"use client"

import styled from "@emotion/styled"
import { Button } from "@mui/material"
import { CheckSuccessIcon, X2Icon } from "./icons"

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 100%;
  min-height: 400px;
`

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  width: 100%;
`

const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  width: 100%;
`

const StyledIconCircle = styled.div<{ $isSuccess: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 98px;
  height: 98px;
  border-radius: 44px;
  padding: 4px;
  background-color: ${({ $isSuccess }) => ($isSuccess ? "#e3f8e6" : "rgba(215, 86, 103, 0.1)")};
  overflow: hidden;

  svg {
    width: 66px;
    height: 66px;
  }
`

const StyledText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
  color: #0e2846;
`

const StyledTitle = styled.h3`
  margin: 0;
  font-size: 30px;
  font-weight: 400;
  line-height: 1.25;
  letter-spacing: -0.6px;
  color: #0e2846;
  text-transform: capitalize;
  text-align: center;

  ${(props) => props.theme.breakpoints.up("md")} {
    font-size: 40px;
    letter-spacing: -0.8px;
  }
`

const StyledSubtitle = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: #0e2846;
  text-align: center;

  ${(props) => props.theme.breakpoints.up("md")} {
    font-size: 18px;
  }
`

type PortFormResultStateProps = {
  isSuccess: boolean
  title: string
  subtitle: string
  buttonText: string
  onButtonClick: () => void
}

export default function PortFormResultState({
  isSuccess,
  title,
  subtitle,
  buttonText,
  onButtonClick,
}: PortFormResultStateProps) {
  return (
    <StyledContainer>
      <StyledContent>
        <StyledTextWrapper>
          <StyledIconCircle $isSuccess={isSuccess}>
            {isSuccess ? (
              <CheckSuccessIcon width={66} height={66} />
            ) : (
              <X2Icon width={66} height={66} />
            )}
          </StyledIconCircle>
          <StyledText>
            <StyledTitle>{title}</StyledTitle>
            <StyledSubtitle>{subtitle}</StyledSubtitle>
          </StyledText>
        </StyledTextWrapper>
        <Button
          variant="contained"
          sx={{
            fontSize: { xs: "18px" },
            minWidth: { xs: "103px", md: "200px" },
            height: { xs: "48px" },
          }}
          size="large"
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
      </StyledContent>
    </StyledContainer>
  )
}
